import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { CopilotDrawer } from "../../gravun/ai/CopilotDrawer";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <ErrorBoundary FallbackComponent={Error}>
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {children}
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      {/* Copilot floats above the tab bar: mobile has no topbar, and a
          feature you cannot reach on the phone in your pocket may as well
          not exist for field staff. */}
      <div className="fixed bottom-20 right-4 z-40 [&>button]:size-11 [&>button]:justify-center [&>button]:rounded-full [&>button]:border [&>button]:border-border [&>button]:bg-card [&>button]:shadow-md [&>button_span]:hidden">
        <CopilotDrawer />
      </div>
      <Notification mobileOffset={{ bottom: "72px" }} />
    </>
  );
};
